import React from 'react';
import PropTypes from 'prop-types';
import {
  CtaButton,
  CtaShell,
  IMAGE_SIZES,
  ResponsiveImage,
} from '@web/molecules';
import {
  StyledSimpleCallout,
  Inner,
  ImageWrapper,
  Content,
  Body,
  ButtonContainer,
  Description,
} from './styles.js';

export const SimpleCallout = ({
  image,
  body,
  level = 'h3',
  link,
  description,
  bgColor = 'background.base',
  bodyFontColor = 'text.primary',
  bodyTypography = 'heading3',
  descFontColor = 'text.primary',
  descTypography = 'heading4',
}) => {
  return (
    <StyledSimpleCallout $bgColor={bgColor}>
      <Inner $alignment={link.alignment}>
        {image && (
          <ImageWrapper>
            <ResponsiveImage {...image} sizes={IMAGE_SIZES.half} />
          </ImageWrapper>
        )}
        <Content>
          <Body
            as={level}
            $fontColor={bodyFontColor}
            $typography={bodyTypography}
          >
            {body}
          </Body>
          {description && (
            <Description
              $typography={descTypography}
              $fontColor={descFontColor}
            >
              {description}
            </Description>
          )}
        </Content>
        <ButtonContainer $alignment={link.alignment}>
          <CtaShell
            alignment={link.alignment}
            fullWidth={link.fullWidth}
            fullWidthMobile={link.fullWidthMobile}
            fullWidthDesktop={link.fullWidthDesktop}
          >
            <CtaButton
              {...link}
              href={link.target}
              variant={link.variant}
              icon={link.icon}
              iconAlignment={link.iconAlignment}
              headerText={link.headerText || body}
            >
              {link.text}
            </CtaButton>
          </CtaShell>
        </ButtonContainer>
      </Inner>
    </StyledSimpleCallout>
  );
};
SimpleCallout.displayName = 'SimpleCallout';

SimpleCallout.propTypes = {
  image: PropTypes.object.isRequired,
  body: PropTypes.string,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  link: PropTypes.shape({
    text: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
  }).isRequired,
  bgColor: PropTypes.string,
  bodyFontColor: PropTypes.string,
  bodyTypography: PropTypes.string,
  description: PropTypes.string,
  descFontColor: PropTypes.string,
  descTypography: PropTypes.string,
};
